/**
 * @file index.jsx
 * @author Daniel Aguirre
 * @description Dashboard patient card
 */

// Dependencies
import { Col } from 'antd';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const DashboardLinkButton = ({ title, link, icon }) => {
  return (
    <Col xs={24} sm={12} md={12} lg={12} xl={8}>
      <Link to={link}>
        <div className="rounded-xl bg-secondary text-white flex flex-1 flex-row items-center justify-between p-3">
          <div className="flex flex-row items-center">
            {icon}
            <h1 className="ml-3 mb-0 text-white text-lg1">{title}</h1>
          </div>
        </div>
      </Link>
    </Col>
  );
};

/**
 * Component definition of proptypes.
 */
DashboardLinkButton.propTypes = {
  title: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  icon: PropTypes.element.isRequired
};

export default DashboardLinkButton;
